export default __webpack_public_path__ + "assets/images/automation-logs-e22bcae7c8f7430915020e267871f7e7.png";